import React, { Fragment } from 'react';
import { List, Divider } from 'semantic-ui-react';
import InformationItem from './InformationItem';
import { Link } from "react-router-dom";
import FlightDate from './FlightDate'

const EMPTY_FLIGHT = {
  airline: {},
  airportOrigin: {},
  airportDestination: {}
}

class ClaimSummary extends React.Component {
  createMarkup(airportOriginName, airportOriginIata, airportDestinationName, airportDestinationIata) {
    return {__html: `${ airportOriginName } (${ airportOriginIata })
    <i aria-hidden="true" class="angle right icon" style="min-width: 25px;"></i>
    ${ airportDestinationName } (${ airportDestinationIata })`};
  }


  render = () => {
    const claim = this.props.claim || {}
    const {
      passengerTicket,
      flight
    } =  claim

    return (<List>
      { this.renderPassengerTicketSummary(passengerTicket) }
      <Divider hidden/>
      { this.renderClaimSummary(claim) }
      <Divider hidden/>
      { this.renderFlightSummary(flight) }
    </List>)
  }

  renderPassengerTicketSummary(passengerTicket){
    const {
      passengerFirstName,
      passengerLastName,
      passengerEmail,
      passengerPhone,
      passengerLanguage
    } = passengerTicket || {}

    return (
      <Fragment>
        <InformationItem
          icon={'user'}
          content={`${passengerFirstName} ${passengerLastName}`}
          info={'PAX name'} />
        <InformationItem
          icon={'send'}
          content={ passengerEmail }
          info={'PAX email'} />
        <InformationItem
          icon={'phone'}
          content={ passengerPhone }
          info={'PAX telephone'} />
        <InformationItem
          icon={'talk outline'}
          content={ passengerLanguage }
          info={'PAX language'} />
      </Fragment>
    )
  }

  renderClaimSummary(claim){
    const {
      id,
      reason,
      crmState
    } = claim
    const affiliate = claim.affiliate || {}

    return (
      <Fragment>
        <InformationItem
          icon={'info circle'}
          content={ <Link to={'/claim/' + id} target="_blank" rel="noopener">#{ id }</Link> }
          info={'Claim Id'} />
        <InformationItem
          icon={'level down'}
          content={ crmState }
          info={'Claim status'} />
        <InformationItem
          icon={'flag'}
          content={ reason }
          info={'Reason of disturbance'} />
        <InformationItem
          icon={'suitcase'}
          content={ affiliate.name }
          info={'Affiliate'} />
      </Fragment>
    )
  }

  renderFlightSummary(flight){
    const {
      number,
      localDepartureDate,
      localArrivalDate,
      airline,
      airportOrigin,
      airportDestination
    } = flight || EMPTY_FLIGHT
    const affiliateInfo = airline && `${ airline.name } (${ airline.iata })`
    const flightnumber = airline && `${ airline.iata }${ number }`

    return (
      <Fragment>
        <InformationItem
          icon={'info circle'}
          content={ affiliateInfo }
          info={'Affiliate'} />
        <InformationItem
          icon={'plane'}
          content={<span dangerouslySetInnerHTML={this.createMarkup(airportOrigin.name, airportOrigin.iata, airportDestination.name, airportDestination.iata)} />}
          info={'Flight origin and destination'} />
        <InformationItem
          icon={'hashtag'}
          content={ flightnumber }
          info={'Flight number'} />
        <InformationItem
          icon={'chevron circle up'}
          content={ <FlightDate date={localDepartureDate}/> }
          info={'Date of departure'} />
        <InformationItem
          icon={'chevron circle down'}
          content={ <FlightDate date={localArrivalDate}/> }
          info={'Date of arrival'} />
      </Fragment>
    )
  }
}

export default ClaimSummary;



// WEBPACK FOOTER //
// ./src/component/ClaimSummary.js